import React from "react"
import { Link } from "gatsby"
import Img from "@kframesa/react-crosscast-lazy-image"
import ellipsize from "ellipsize"

import { sArticle } from "../styled/article"
import { getPostUrl } from "../utilities"

const Article = ({ as, post, index, className, hideCategory }) => {
  const getFluidConfig = () => {
    if (className === `first-hot` && index === 0) {
      return {
        maxWidth: 634,
        size: 385,
        step: 94,
        sizes: [`(max-width: 425px) 385px`, `(max-width: 768px) 479px`, `634px`],
      }
    }

    return {
      maxWidth: 385,
      size: 307,
      step: 47,
      sizes: [`(max-width: 425px) 385px`, `(max-width: 768px) 354px`, `307px`],
    }
  }

  return (
    <sArticle.Item as={as} className={className}>
      <Link to={getPostUrl(post.slug)}>
        <sArticle.Image>
          <Img
            platformSlug={post.featuredImage.platformSlug}
            imageGuid={post.featuredImage.guid}
            type={post.featuredImage.type}
            alt={post.featuredImage.alt}
            fluid={getFluidConfig()}
            aspectRatio={0.5625}
            ext={post.featuredImage.ext}
          />
        </sArticle.Image>
        <sArticle.Caption>
          {!hideCategory && post.category ? <span>{post.category.name}</span> : null}
          <h3>{post.title}</h3>
          <p>{className === `first-hot` && index === 0 ? post.abstract : ellipsize(post.abstract, 180)}</p>
        </sArticle.Caption>
      </Link>
    </sArticle.Item>
  )
}

export default Article
